import React from 'react';

class FormatoSimplificado1347531PlanPremiumPlus_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347531 Plan Premium +';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347531_PREMIUM%2B_2024_V2.pdf?alt=media&token=d4378ff1-046b-4e2f-9106-e10545c36010';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347531PlanPremiumPlus_pdf